import { create } from 'zustand';
import styles from './Toast.module.css';

export type ToastKind = 'info' | 'success' | 'error';
interface ToastItem {
  id: number;
  kind: ToastKind;
  text: string;
}

interface ToastState {
  items: ToastItem[];
  push: (kind: ToastKind, text: string) => void;
  remove: (id: number) => void;
}

let nextId = 1;
const useToastStore = create<ToastState>((set) => ({
  items: [],
  push: (kind, text) => {
    const id = nextId++;
    set((s) => ({ items: [...s.items, { id, kind, text }] }));
    setTimeout(() => {
      set((s) => ({ items: s.items.filter((t) => t.id !== id) }));
    }, 3500);
  },
  remove: (id) => set((s) => ({ items: s.items.filter((t) => t.id !== id) })),
}));

// eslint-disable-next-line react-refresh/only-export-components
export const toast = {
  info: (text: string): void => useToastStore.getState().push('info', text),
  success: (text: string): void => useToastStore.getState().push('success', text),
  error: (text: string): void => useToastStore.getState().push('error', text),
};

export function ToastRoot(): JSX.Element {
  const items = useToastStore((s) => s.items);
  return (
    <div className={styles.root}>
      {items.map((t) => (
        <div
          key={t.id}
          className={[
            styles.toast,
            t.kind === 'error' && styles.error,
            t.kind === 'success' && styles.success,
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
